import { Calculation } from "models";

export enum CROP_TYPE {
  MAIN = "MAIN",
  SIDE = "SIDE",
}

export enum CROP_EXPLORER_RESULT_TYPE {
  PAYOUT = "PAYOUT",
  EMISSION = "EMISSION",
}

export enum CROP_EXPLORER_RESULT_CALCULATION_TYPE {
  TOTAL = "TOTAL",
  PER_HA = "PER_HA",
}

export enum CROP_EXPLORER_RESULT_TOGGLE_OPTION {
  YEAR = "YEAR",
  CROP_PRACTICE = "CROP_PRACTICE",
}

export type CropExplorationTemplateRequest = {
  bauYears?: number[];
  name: string;
  yearlyEntryYears?: number[];
};

export type CropExplorationRequest = CropExplorationTemplateRequest & {
  country: string;
  hectares: number;
  pseudoUserId?: string | null;
  userId?: string | null;
  zipCode: string;
};

export type CropExplorationEntry = {
  id: string;
  name: string;
  cropId: string;
  residue: boolean;
  type: CROP_TYPE;
  year: number;
};

export type CropExplorationEntryRequest = {
  cropId: string;
  residue: boolean;
  type: CROP_TYPE;
  year: number;
  wasRecommended?: boolean;
};

export type AddCropExplorationEntryRequest = {
  cropExplorationId: string;
  crop: CropExplorationEntryRequest;
};

export type EntriesByCrops = {
  year: number;
  main: CropExplorationEntry | null;
  side: CropExplorationEntry[];
};

export type CropExplorationTemplateResponse = CropExplorationTemplateRequest & {
  id: string;
  bauYears: number[];
  bauEntries: EntriesByCrops[];
  yearlyEntryYears: number[];
  yearlyEntries: EntriesByCrops[];
  createdAt: string;
  updatedAt: string;
};

export type CropExplorationResponse = CropExplorationRequest & {
  id: string;
  bauYears: number[];
  bauEntries: EntriesByCrops[];
  regionId: string;
  yearlyEntryYears: number[];
  yearlyEntries: EntriesByCrops[];
  calculation: Calculation;
  yearlySideCropRecommendations: Recommendation[];
  createdAt: string;
  updatedAt: string;
};

export type CropExplorationCreationResponse = {
  id: string;
  success: boolean;
};

export type CropExplorationEntryCreationResponse = {
  id: string;
};

export enum CROP_CREATION_MODAL_TYPE {
  ADD = "add",
  EDIT = "edit",
}

export enum YEAR_TYPE {
  BASELINE = "BASELINE",
  YEARLY = "YEARLY",
}

export type Recommendation = {
  year: number;
  crops: RecommendedCrop[];
  basedOnYears: number[];
};

export type RecommendedCrop = {
  cropName: string;
  cropId: string;
  residue: boolean;
  averagePayoutValue: number;
};
